import { createAsyncAction } from 'typesafe-actions'
import { IGlobalDeliveryDay } from '../../../api'

export const FETCH_GLOBAL_DELIVERY_DAYS = createAsyncAction(
  'order/FETCH_GLOBAL_DELIVERY_DAYS',
  'order/FETCH_GLOBAL_DELIVERY_DAYS_SUCCESS',
  'order/FETCH_GLOBAL_DELIVERY_DAYS_FAILURE',
  'order/FETCH_GLOBAL_DELIVERY_DAYS_CANCEL',
)<undefined, IGlobalDeliveryDay[], Error, undefined>()
